import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles((theme) => ({
  iconButton: {
    color: theme.colorText,
  },
  translationButtonText: {
    color: theme.colorText,
    fontSize: '1rem',
    textTransform: 'none',
  },
  translationExtendedButton: {
    margin: '0px 5px',

    '@media (max-width: 979px)': {
      display: 'none',
    },
  },
  translationMinorButton: {
    display: 'none',

    '@media (max-width: 979px)': {
      display: 'block',
    },
  },
  menuPopOver: {
    '& .MuiPaper-root': {
      backgroundColor: theme.colorTertiaryBackground,
      color: theme.colorText,
    },
  },
}));

export default useStyles;
